import { lazy } from 'react';

import { PathwayModalRenderer } from '@/components/popups/PathwayModal';

import LicenseeLocationPicker from './LicenseeLocationPicker';

import { env } from '@/env';
import { SmartSearchAnnouncementBanner } from '@/routes/Explore/Operations/SmartSearchAnnouncementBanner';

const Banner = lazy(() => import('../Permissions/Banner'));
const XpHostBanner = lazy(
  () => import('@/components/developer-menu/engine/XpHostBanner'),
);

interface LayoutWrapperProps {
  children: React.ReactNode;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => (
  <>
    {env.REACT_APP_ENV !== 'prod' && <Banner />}
    {env.REACT_APP_ENV !== 'prod' && <XpHostBanner />}
    <SmartSearchAnnouncementBanner />
    {children}
    <LicenseeLocationPicker />
    <PathwayModalRenderer />
  </>
);

export default LayoutWrapper;
